import {
    calculatePercentageDifference,
    formatPercentages,
    formatUSD,
} from '../../helpers';

type AreaChartKpiProps = {
    data: {
        time: string;
        value: number;
    }[];
    activePayload: number | undefined;
    selectedTimeframe: string;
    label: string;
    activePayloadLabel: string;
    isLoading: boolean;
};

const AreaChartKpi: React.FC<AreaChartKpiProps> = ({
    isLoading,
    data,
    activePayload,
    selectedTimeframe,
    label,
    activePayloadLabel,
}) => {
    const latestValue = data[data.length - 1].value;
    const earliestValue = data[0].value;

    const dailyDifference = calculatePercentageDifference(latestValue, earliestValue);
    const activeDifference = activePayload
        ? +calculatePercentageDifference(activePayload, earliestValue)
        : 0;

    return (
        <div className='chart-kpis'>
            <div className='chart-kpis-container'>
                <div>
                    <div className='kpi-title'>
                        <span>{label}</span>
                        {isLoading ? (
                            <span>-</span>
                        ) : (
                            <>
                                <span
                                    className={
                                        +dailyDifference >= 0 ? 'arrow-up' : 'arrow-down'
                                    }
                                />
                                <span>
                                    {formatPercentages(Math.abs(+dailyDifference))}% (
                                    {selectedTimeframe})
                                </span>
                            </>
                        )}
                    </div>
                    <div className='kpi-value'>
                        {isLoading ? '-' : formatUSD(data[data.length - 1].value)}
                    </div>
                </div>
                {!!activePayload && (
                    <div>
                        <div className='kpi-title'>
                            <span>{activePayloadLabel}</span>
                            <span
                                className={
                                    activeDifference >= 0 ? 'arrow-up' : 'arrow-down'
                                }
                            />
                            <span>{formatPercentages(Math.abs(+activeDifference))}%</span>
                        </div>
                        <div className='kpi-value'>{formatUSD(activePayload)}</div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default AreaChartKpi;
